import { render, staticRenderFns } from "./AppraisalDashboard.vue?vue&type=template&id=2f27cc92&scoped=true"
import script from "./AppraisalDashboard.vue?vue&type=script&lang=js"
export * from "./AppraisalDashboard.vue?vue&type=script&lang=js"
import style0 from "./AppraisalDashboard.vue?vue&type=style&index=0&id=2f27cc92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f27cc92",
  null
  
)

export default component.exports